module.exports = __webpack_public_path__ + "img/16.e6f22bc1.png";